<div class="w-full min-h-screen bg-white p-3 md:p-5">
  <p-toast></p-toast>

  <p-confirmDialog
    [breakpoints]="{'960px': '75vw', '640px': '90vw'}"
    [style]="{width: '50vw'}"
    acceptLabel="Sí"
    rejectLabel="Cancelar"
    rejectButtonStyleClass="p-button-danger">
  </p-confirmDialog>

  <div class="flex flex-column md:flex-row justify-content-between align-items-center gap-3 mb-5">
    <span class="p-input-icon-left w-full md:w-auto">
      <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')"
             placeholder="Buscar origen de venta..."
             class="w-full md:w-20rem border-round-3xl input-search" />
    </span>
    <button pButton label="Nuevo Origen de Venta" icon="pi pi-plus" class="p-button-black border-round-3xl" (click)="openNew()"></button>
  </div>

  <p-table #dt [value]="list" [rows]="10" [paginator]="true"
           [globalFilterFields]="['nombreOrigenVenta']"
           [tableStyle]="{ 'min-width': '40rem' }"
           [rowHover]="true"
           styleClass="p-datatable-sm">
    <ng-template pTemplate="header">
      <tr class="uppercase text-xs text-500">
        <th pSortableColumn="nombreOrigenVenta">Nombre <p-sortIcon field="nombreOrigenVenta"></p-sortIcon></th>
        <th class="text-center">Estado</th>
        <th class="text-center">Acciones</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr class="text-sm">
        <td class="font-bold text-900">{{ row.nombreOrigenVenta }}</td>
        <td class="text-center">
          <span [class]="'text-xs font-bold px-2 py-1 border-round ' + (row.isActive ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700')">
            {{ row.isActive ? 'ACTIVO' : 'INACTIVO' }}
          </span>
        </td>
        <td class="text-center">
          <div class="flex justify-content-center gap-2">
            <button pButton icon="pi pi-pencil" class="p-button-text p-button-rounded text-600 hover:text-900" (click)="edit(row)" pTooltip="Editar"></button>
            <button pButton icon="pi pi-power-off" class="p-button-text p-button-rounded" [ngClass]="row.isActive ? 'text-red-400 hover:text-red-600' : 'text-green-400 hover:text-green-600'" (click)="toggle(row)" pTooltip="Activar/Desactivar"></button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog [(visible)]="dialog" header="Detalles de Origen de Venta" [modal]="true"
            [breakpoints]="{'960px': '75vw', '640px': '95vw'}"
            [style]="{width: '500px'}" styleClass="p-fluid">
    <div class="flex flex-column gap-3 pt-2">
      <div class="field">
        <label class="font-bold">Nombre</label>
        <input pInputText [(ngModel)]="item.nombreOrigenVenta" required autofocus placeholder="Ej: Instagram" />
        <small class="p-error" *ngIf="submitted && !item.nombreOrigenVenta">Nombre requerido.</small>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text text-900" (click)="dialog = false"></button>
      <button pButton label="Guardar" icon="pi pi-check" class="p-button-black" (click)="save()"></button>
    </ng-template>
  </p-dialog>
</div>
